// General css
import 'assets/css/animations.css';
import 'assets/css/reset.css';
import 'assets/css/general.css';
import 'assets/css/grid.css';
import 'assets/css/buttons.css';
import 'assets/css/flexbox.css';
import 'assets/css/forms.css';
import 'assets/css/tables.css';
import 'assets/css/icons.css';
import 'assets/css/intel-bubble.css';
import 'assets/css/lini-tweaks.css';
import 'assets/css/loading-bar.css';
import 'assets/css/page-toolbar.css';
import 'assets/css/post-edit.css';
import 'assets/css/posts.css';
import 'assets/css/suggester.css';
import 'assets/css/reusable.css';
import 'assets/css/reusable-hub.css';
import 'assets/css/ripple.css';
// angular
import angular from 'angular';
// BEGIN Vendor modules
import 'angular-bootstrap-colorpicker';
import 'angular-clipboard';
import 'angular-loading-bar';
import 'angular-loading-bar/build/loading-bar.css';
import 'angular-sanitize';
import 'angular-sortable-view';
import 'angular-ui-router';
import 'angular-utils-pagination';
import 'components/sharpr/utilsPagination/utilsPaginationStyles.css';
import 'moment-parseplus';
import 'components/sharpr/angularRipple/angular-ripple.js';
// END
// BEGIN Import Sharpr modules that register themselves on angular
import 'components/sharpr/autosizeTextarea/autosizeDirective.js';
import 'components/sharpr/accessRules/accessRulesModule.js';
import 'components/sharpr/accordion/accordionModule';
import 'components/sharpr/addContent/addContentModule';
import 'components/sharpr/afterChange/afterChangeModule';
import 'components/sharpr/afterPaste/afterPasteModule';
import 'components/sharpr/announcement/announcementModule';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/appendTo/appendToModule';
import 'components/sharpr/att/list/icons/attListIconsModule';
import 'components/sharpr/att/list/popup/attListPopupModule';
import 'components/sharpr/att/list/popup/attListThumbnailsModule';
import 'components/sharpr/att/list/thumbnails/attListThumbnailsModule';
import 'components/sharpr/att/service/attServiceModule';
import 'components/sharpr/att/slideshow/attSlideshowModule';
import 'components/sharpr/att/viewer/audio/attViewerAudioModule';
import 'components/sharpr/att/viewer/image/attViewerImageModule';
import 'components/sharpr/att/viewer/other/attViewerOtherModule';
import 'components/sharpr/att/viewer/prizm/attViewerPrizmModule';
import 'components/sharpr/att/viewer/video/attViewerVideoModule';
import 'components/sharpr/audioPlayer/audioPlayerModule';
import 'components/sharpr/auth/AuthModule';
import 'components/sharpr/autoArchive/autoArchiveModule';
import 'components/sharpr/autopatch/autopatchModule';
import 'components/sharpr/avatar/avatarModule';
import 'components/sharpr/bytesToText/bytesToTextModule';
import 'components/sharpr/cfg/cfgModule';
import 'components/sharpr/charsRemain/charsRemainModule';
import 'components/sharpr/chart/bar/horizontal/chartBarHorizontalModule';
import 'components/sharpr/checkboxList/checkboxListModule';
import 'components/sharpr/chooseHomePage/chooseHomePageModule';
import 'components/sharpr/clearableInput/clearableInputModule';
import 'components/sharpr/clickToDownload/clickToDownloadModule';
import 'components/sharpr/clientChooser/clientChooserModule';
import 'components/sharpr/collapsible/collapsibleModule';
import 'components/sharpr/colorScheme/colorSchemeModule';
import 'components/sharpr/columnized/columnizedModule';
import 'components/sharpr/commentButton/commentButtonModule';
import 'components/sharpr/contextmenu/contextmenuModule';
import 'components/sharpr/cookies/cookiesModule';
import 'components/sharpr/copyToClipboard/copyToClipboardModule';
import 'components/sharpr/customColorChooser/customColorChooserModule';
import 'components/sharpr/dashboard/dashboardModule';
import 'components/sharpr/dataTable/dataTableModule';
import 'components/sharpr/date/dateFormat/dateFormatModule';
import 'components/sharpr/date/dateHuman/dateHumanModule';
import 'components/sharpr/date/dateOffset/dateOffsetModule';
import 'components/sharpr/date/datePicker/datePickerModule';
import 'components/sharpr/date/dateRangePicker/dateRangePickerModule';
import 'components/sharpr/detectFocus/detectFocusModule';
import 'components/sharpr/duration/human/durationHumanModule';
import 'components/sharpr/editableField/editableFieldModule';
import 'components/sharpr/ellipsis/ellipsisModule';
import 'components/sharpr/emailPostClicks/emailPostClicksModule';
import 'components/sharpr/embed/edit/embedEditModule';
import 'components/sharpr/embed/iframe/embedIframeModule';
import 'components/sharpr/embed/listing/embedListingModule';
import 'components/sharpr/embed/powerBi/embedPowerBiModule';
import 'components/sharpr/embed/tableau/embedTableauModule';
import 'components/sharpr/errorLogger/errorLoggerModule';
import 'components/sharpr/errorScreen/errorScreenModule';
import 'components/sharpr/eventTracker/eventTrackerModule';
import 'components/sharpr/fauxSelect/fauxSelectModule';
import 'components/sharpr/file/drag/fileDragModule';
import 'components/sharpr/file/duplicates/modal/fileDuplicatesModalModule';
import 'components/sharpr/filter/by/string/filterByStringModule';
import 'components/sharpr/filterMessage/filterMessageModule';
import 'components/sharpr/fineTune/checkboxes/fineTuneCheckboxesModule';
import 'components/sharpr/fineTune/multihub/fineTuneMultihubModule';
import 'components/sharpr/fineTune/posts/fineTunePostsModule';
import 'components/sharpr/fineTune/typeahead/fineTuneTypeaheadModule';
import 'components/sharpr/fineTune/videos/fineTuneVideosModule';
import 'components/sharpr/fitText/fitTextModule';
import 'components/sharpr/focusWhen/focusWhenModule';
import 'components/sharpr/fullscreen/fullscreenModule';
import 'components/sharpr/header/avatar/headerAvatarModule';
import 'components/sharpr/header/headerModule';
import 'components/sharpr/html/bindHtml/bindHtmlModule';
import 'components/sharpr/html/htmlLinky/htmlLinkyModule';
import 'components/sharpr/html/htmlUnmixContent/htmlUnmixContentModule';
import 'components/sharpr/html/toText/htmlToTextModule';
import 'components/sharpr/hubChooser/hubChooserModule';
import 'components/sharpr/identity/identityModule';
import 'components/sharpr/image/carousel/imageCarouselModule';
import 'components/sharpr/image/imageModule';
import 'components/sharpr/image/loaded/imageLoadedModule';
import 'components/sharpr/image/picker/choices/imagePickerChoicesModule';
import 'components/sharpr/image/picker/imagePickerModule';
import 'components/sharpr/image/picker/search/imagePickerSearchModule';
import 'components/sharpr/image/resized/imageResizedModule';
import 'components/sharpr/image/sizer/imageSizerModule';
import 'components/sharpr/impersonationBar/impersonationBarModule';
import 'components/sharpr/impersonatorHelper/impersonatorHelperModule';
import 'components/sharpr/input/autowidth/inputAutowidthModule';
import 'components/sharpr/input/icon/inputIconModule';
import 'components/sharpr/layout/admin/layoutAdminModule';
import 'components/sharpr/layout/biReports/layoutBiReportsModule';
import 'components/sharpr/layout/userPrefs/layoutUserPrefsModule';
import 'components/sharpr/leftOrMiddleClick/leftOrMiddleClickModule';
import 'components/sharpr/likeButton/likeButtonModule';
import 'components/sharpr/location/LocationModule';
import 'components/sharpr/logger/loggerModule';
import 'components/sharpr/login/loginModule';
import 'components/sharpr/masonryTimer/masonryTimerModule';
import 'components/sharpr/mentionable/mentionableModule';
import 'components/sharpr/menu/menuModule';
import 'components/sharpr/metric/event/item/metricEventItemModule';
import 'components/sharpr/middleClick/middleClickModule';
import 'components/sharpr/modal/modalModule';
import 'components/sharpr/msalAuth/msalAuthModule';
import 'components/sharpr/multiselect/multiselectModule';
import 'components/sharpr/neatSelect/neatSelectModule';
import 'components/sharpr/nl2br/nl2brModule';
import 'components/sharpr/notifications/notificationsModule';
import 'components/sharpr/onInput/onInputModule';
import 'components/sharpr/onOutsideClick/onOutsideClickModule';
import 'components/sharpr/overlay/overlayModule';
import 'components/sharpr/pagination/paginationModule';
import 'components/sharpr/partnerLinks/partnerLinksModule';
import 'components/sharpr/patch/patchModule';
import 'components/sharpr/percentRounding/percentRoundingModule';
import 'components/sharpr/photoCollage/photoCollageModule';
import 'components/sharpr/pocketLint/pocketLintModule';
import 'components/sharpr/post/actions/postActionsModule';
import 'components/sharpr/post/bubble/postBubbleModule';
import 'components/sharpr/post/categoryBar/postCategoryBarModule';
import 'components/sharpr/post/classificationBar/postClassificationBarModule';
import 'components/sharpr/post/classificationWithPostType/postClassificationWithPostTypeModule';
import 'components/sharpr/post/credit/postCreditModule';
import 'components/sharpr/post/grid/intel/postGridIntelModule';
import 'components/sharpr/post/hero/postHeroModule';
import 'components/sharpr/post/history/postHistoryModule';
import 'components/sharpr/post/image/postImageModule';
import 'components/sharpr/post/imageArea/postImageAreaModule';
import 'components/sharpr/post/indicators/postIndicatorsModule';
import 'components/sharpr/post/pin/body/postPinBodyModule';
import 'components/sharpr/post/pin/footer/postPinFooterModule';
import 'components/sharpr/post/pin/intel/postPinIntelModule';
import 'components/sharpr/post/pin/multihub/postPinMultihubModule';
import 'components/sharpr/post/pin/unapproved/postPinUnapprovedModule';
import 'components/sharpr/post/editor/postEditorModule.js';
import 'components/sharpr/post/readMore/postReadMoreModule';
import 'components/sharpr/post/scopeLinkedPosts/scopeLinkedPostsModule';
import 'components/sharpr/post/service/postServiceModule';
import 'components/sharpr/post/simple/postSimpleModule';
import 'components/sharpr/post/tabular/intel/postTabularIntelModule';
import 'components/sharpr/post/tabular/multihub/postTabularMultihubModule';
import 'components/sharpr/post/taxonomies/postTaxonomyModule';
import 'components/sharpr/postSource/postSourceModule';
import 'components/sharpr/progress/background/progressBackgroundModule';
import 'components/sharpr/progress/bar/progressBarModule';
import 'components/sharpr/pubnub/pubnubModule';
import 'components/sharpr/reactHref/reactHrefModule';
import 'components/sharpr/richtext/richtextModule';
import 'components/sharpr/richtitle/richtitleModule';
import 'components/sharpr/routerTitle/routerTitleModule';
import 'components/sharpr/savedSearches/savedSearchesModule';
import 'components/sharpr/scrollManager/scrollManagerModule';
import 'components/sharpr/search/bar/searchBarModule';
import 'components/sharpr/search/input/searchInputModule';
import 'components/sharpr/search/pills/searchPillsModule';
import 'components/sharpr/search/termsAndTuner/searchTermsAndTunerModule';
import 'components/sharpr/searchAndChoose/searchAndChooseModule';
import 'components/sharpr/secureStorage/SecureStorageModule';
import 'components/sharpr/select/selectModule';
import 'components/sharpr/sendReferrer/sendReferrerModule';
import 'components/sharpr/settingsTable/settingsTableModule';
import 'components/sharpr/sharprEventTracker/sharprEventTrackerModule';
import 'components/sharpr/slideHorizontal/slideHorizontalModule';
import 'components/sharpr/snapEngage/snapEngageModule';
import 'components/sharpr/sort/sortModule';
import 'components/sharpr/spinner/spinnerModule';
import 'components/sharpr/sticky/stickyModule';
import 'components/sharpr/storage/storageModule';
import 'components/sharpr/tabs/tabsModule';
import 'components/sharpr/tagCloud/tagCloudModule';
import 'components/sharpr/taxonomy/taxonomyModule';
import 'components/sharpr/theme/themeModule';
import 'components/sharpr/time/picker/timePickerModule';
import 'components/sharpr/time/zone/picker/timeZonePickerModule';
import 'components/sharpr/time/zone/service/timeZoneModule';
import 'components/sharpr/topContributors/bar/topContributorsBarModule';
import 'components/sharpr/truncate/truncateModule';
import 'components/sharpr/trusted/trustedModule';
import 'components/sharpr/typeahead/multi/typeaheadMultiModule';
import 'components/sharpr/typeahead/select/account/typeaheadSelectAccountModule';
import 'components/sharpr/typeahead/select/hub/typeaheadSelectHubModule';
import 'components/sharpr/typeahead/select/typeaheadSelectModule';
import 'components/sharpr/typeahead/single/typeaheadSingleModule';
import 'components/sharpr/uiSref/uiSrefModule';
import 'components/sharpr/upload/area/uploadAreaModule';
import 'components/sharpr/upload/uploadModule';
import 'components/sharpr/url/data/urlDataModule';
import 'components/sharpr/user/edit/userEditModule';
import 'components/sharpr/videoPlayer/videoPlayerModule';
import 'components/sharpr/visualTag/display/visualTagDisplayModule';
import 'components/sharpr/visualTag/picker/visualTagPickerModule';
import 'components/sharpr/zIndex/top/zIndexTopModule';
// END
// General Config
import { setDocumentClass } from 'components/sharpr/setDocumentClass/setDocumentClass';
import { injectPageViewTracker } from 'components/sharpr/eventTracker/EventTrackerService';
import { injectImpersonatorHelper } from '../sharpr/impersonatorHelper/ImpersonatorHelperService';
import { restrictRouteByPermission } from 'components/sharpr/identity/IdentityService';
import { checkForAnnouncements } from 'components/sharpr/announcement/service/AnnouncementService';
// import { handleStateChangeError } from 'components/sharpr/handleStateChangeError/handleStateChangeError';
import { setDebugMode } from 'components/sharpr/setDebugMode/setDebugMode';
import { hubBaseRoute } from './base/hubBaseRoute';
import { hubLoggedinBaseRoute } from './base/hubLoggedinBaseRoute';
import { setSceOptions } from 'components/sharpr/setSceOptions/setSceOptions';
// BEGIN Import controllers
import AffiliationAnalytics from './Affiliation/Analytics/AffiliationAnalyticsCtrl';
import AffiliationHub from './Affiliation/Hub/AffiliationHubCtrl';
import AffiliationListing from './Affiliation/Listing/AffiliationListingCtrl';
import CrossPostSubscriptions from './CrossPost/Subscriptions/CrossPostSubscriptionsCtrl';
import Http404 from './Error/Http404/Http404Ctrl';
import NewsroomChooser from './Newsroom/Chooser/NewsroomChooserCtrl';
import NewsroomColorScheme from './Newsroom/ColorScheme/NewsroomColorSchemeCtrl';
import NewsroomScreenAddedit from './Newsroom/Screen/Addedit/NewsroomScreenAddeditCtrl';
import NewsroomScreenListing from './Newsroom/Screen/Listing/NewsroomScreenListingCtrl';
import NewsroomScreenRunMasonry from './Newsroom/Screen/Run/Masonry/NewsroomScreenRunMasonryCtrl';
import NewsroomScreenRunSingle from './Newsroom/Screen/Run/Single/NewsroomScreenRunSingleCtrl';
import NewsroomScreenRunTwitter from './Newsroom/Screen/Run/Twitter/NewsroomScreenRunTwitterCtrl';
import NewsroomScreenRunVideo from './Newsroom/Screen/Run/Video/NewsroomScreenRunVideoCtrl';
import PostDetail from './Post/Detail/PostDetailCtrl';
import { AffiliationLanguageRoute } from './Affiliation/Language/AffiliationLanguageCtrl';
import { AffiliationNewHubRoute } from './Affiliation/NewHub/AffiliationNewHubCtrl';
import { AutoEmailRoute } from './Email/Auto/AutoEmailCtrl';
import { CategoryManagerRoute } from './Category/Manager/CategoryManagerCtrl';
import { ClassificationManagerRoute } from './Classification/Manager/ClassificationManagerCtrl';
import { ColumnarStoryBoardRoute } from './StoryBoard/Columnar/StoryBoardColumnarCtrl';
import { CurateSearchRoute } from './Curate/Search/CurateSearchCtrl';
import { CustomLinkImportRoute } from './CustomLink/Import/CustomLinkImportCtrl';
import { EcosystemOverviewRoute } from './Ecosystem/Overview/EcosystemOverviewCtrl';
import { EmailAddressBookRoute } from './Email/AddressBook/EmailAddressBookCtrl';
import { EmailAutoEmailReportRoute } from './Email/AutoEmail/Report/EmailAutoEmailReportCtrl';
import { EmailComposeRoute } from './Email/Compose/EmailComposeCtrl';
import { EmailContactsEditRoute } from './Email/Contacts/Edit/EmailContactsEditCtrl';
import { EmailContactsListingRoute } from './Email/Contacts/Listing/EmailContactsListingCtrl';
import { EmailDistListAddUserRoute } from './Email/DistList/AddUser/EmailDistListAddUserCtrl';
import { EmailDistListEditRoute } from './Email/DistList/Edit/EmailDistListEditCtrl';
import { EmailDistListImportRoute } from './Email/DistList/Import/EmailDistListImportCtrl';
import { EmailDistListListingRoute } from './Email/DistList/Listing/EmailDistListListingCtrl';
import { EmailListingRoute } from './Email/Listing/EmailListingCtrl';
import { EmailRecipientsRoute } from './Email/Recipients/EmailRecipientsCtrl';
import { EmailReportRoute } from './Email/Report/EmailReportCtrl';
import { EmailVerificationRoute } from './Email/Verification/EmailVerificationCtrl';
import { EventsSearchRoute } from './Events/Search/EventsSearchCtrl';
import { EventsUsersRoute } from './Events/Users/EventsUsersCtrl';
import { FileDashboardRoute } from './File/Dashboard/FileDashboardCtrl';
import { FileListingRoute } from './File/Listing/FileListingCtrl';
import { FileMetadataListRoute } from './File/MetadataList/FileMetadataListCtrl';
import { FileReportRoute } from './File/Report/FileReportCtrl';
import { FileStatusRoute } from './File/Status/FileStatusCtrl';
import { HubListingRoute } from './Hub/Listing/HubListingCtrl';
import { IntegrationBoxRoute } from './Integration/Box/IntegrationBoxCtrl';
import { IntegrationEmbedRoute } from './Integration/Embed/IntegrationEmbedCtrl';
import { IntegrationIframeRoute } from './Integration/Iframe/IntegrationIframeCtrl';
import { IntegrationManagerRoute } from './Integration/Manager/IntegrationManagerCtrl';
import { IntegrationMsTeamsRoute } from './Integration/MsTeams/IntegrationMsTeamsCtrl';
import { IntegrationSalesforceRoute } from './Integration/Salesforce/IntegrationSalesforceCtrl';
import { IntegrationServicenowAddEditRoute } from './Integration/Servicenow/AddEdit/IntegrationServicenowAddEditCtrl';
import { IntegrationServicenowListingRoute } from './Integration/Servicenow/Listing/IntegrationServicenowListingCtrl';
import { IntegrationSlackRoute } from './Integration/Slack/IntegrationSlackCtrl';
import { KeywordMapAddRoute } from './KeywordMap/Add/KeywordMapAddCtrl';
import { KeywordMapEditRoute } from './KeywordMap/Edit/KeywordMapEditCtrl';
import { KeywordMapImportRoute } from './KeywordMap/Import/KeywordMapImportCtrl';
import { KeywordMapListingRoute } from './KeywordMap/Listing/KeywordMapListingCtrl';
import { MsTeamsPostRoute } from './PushToMsTeams/MsTeamsPostCtrl';
import { NewsroomCustomColorSchemeRoute } from './Newsroom/CustomColorScheme/NewsroomCustomColorSchemeCtrl';
import { PhotoManagerRoute } from './Photo/Manager/PhotoManagerCtrl';
import { PostAttListRoute } from './Post/AttList/PostAttListCtrl';
import { PostBulkUpdateRoute } from './Post/BulkUpdate/PostBulkUpdateCtrl';
import { PostCopyRoute } from './PostCopy/PostCopyCtrl';
import { PostCreateFromExternalRoute } from './Post/Create/PostCreateFromExternalCtrl';
import { PostCreateRoute } from './Post/Create/PostCreateCtrl';
import { PostEditRoute } from './Post/Edit/PostEditCtrl';
import { PostHistoryRoute } from './Post/History/PostHistoryCtrl';
import { PostImportRoute } from './Post/Import/PostImportCtrl';
import { PostListingRoute } from './Post/Listing/PostListingCtrl';
import { PostPickerRoute } from './Post/Picker/PostPickerCtrl';
import { PostUnarchiveRoute } from './Post/Unarchive/PostUnarchiveCtrl';
import { QuestionPhraseListingRoute } from './QuestionPhrase/Listing/QuestionPhraseListingCtrl';
import { ReportLandingRoute } from './Report/Landing/ReportLandingCtrl';
import { ReportTilesRoute } from './Report/Tiles/ReportTilesCtrl';
import { ReportViewerRoute } from './Report/Viewer/ReportViewerCtrl';
import { SearchSuggestRoute } from './Search/Suggest/SearchSuggestCtrl';
import { SearchTestTextRoute } from './Search/Test/Text/SearchTestTextCtrl';
import { SettingsClientCredentialsAddEditRoute } from './Settings/ClientCredentials/AddEdit/SettingsClientCredentialsAddEditCtrl';
import { SettingsClientCredentialsListingRoute } from './Settings/ClientCredentials/Listing/SettingsClientCredentialsListingCtrl';
import { SettingsCookiesAnonymousRoute } from './Settings/Cookies/Anonymous/SettingsCookiesAnonymousCtrl';
import { SettingsCookiesRoute } from './Settings/Cookies/SettingsCookiesCtrl';
import { SettingsElasticSearchIndexesRoute } from './Settings/ElasticSearch/Indexes/SettingsElasticSearchIndexesCtrl';
import { SettingsElasticSearchLanguagesRoute } from './Settings/ElasticSearch/Languages/SettingsElasticSearchLanguagesCtrl';
import { SettingsElasticSearchReindexRoute } from './Settings/ElasticSearch/Reindex/SettingsElasticSearchReindexCtrl';
import { SettingsEmailDomainsRoute } from './Settings/EmailDomains/SettingsEmailDomainsCtrl';
import { SettingsForAccountRoute } from './Settings/ForAccount/SettingsForAccountCtrl';
import { SettingsHubRoute } from './Settings/Hub/SettingsHubCtrl';
import { SettingsSsoLinksRoute } from './Settings/Sso/Links/SettingsSsoLinksCtrl';
import { SlackPostRoute } from './PushToSlack/SlackPostCtrl';
import { SsoAddRoute } from './Sso/Add/SsoAddCtrl';
import { SsoAdminRoute } from './Sso/Admin/SsoAdminCtrl';
import { SsoLinksRoute } from './Sso/Links/SsoLinksCtrl';
import { SsoMetadataRoute } from './Sso/Metadata/SsoMetadataCtrl';
import { SsoNoAccessRoute } from './Sso/NoAccess/SsoNoAccessCtrl';
import { SsoRulesetsRoute } from './Sso/Rulesets/SsoRulesetsCtrl';
import { SsoSpsRoute } from './Sso/Sps/SsoSpsCtrl';
import { SsoStatsRoute } from './Sso/Stats/SsoStatsCtrl';
import { TagManagerRoute } from './Tag/Manager/TagManagerCtrl';
import { TopContributorStandingsRoute } from './TopContributors/Standings/TopContributorStandingsCtrl';
import { TranslationOriginalRoute } from './Translation/Original/TranslationOriginalCtrl';
import { TranslationStatusRoute } from './Translation/Status/TranslationStatusCtrl';
import { TrustedAuthAddEditRoute } from './TrustedAuth/AddEdit/TrustedAuthAddEditCtrl';
import { TrustedAuthListingRoute } from './TrustedAuth/Listing/TrustedAuthListingCtrl';
import { UserAccessHistoryRoute } from './User/Access/History/UserAccessHistoryCtrl';
import { UserActivityRoute } from './User/Activity/UserActivityCtrl';
import { UserEditRoute } from './User/Edit/UserEditCtrl';
import { UserEmailBouncesRoute } from './User/EmailBounces/UserEmailBouncesCtrl';
import { UserImportRoute } from './User/Import/UserImportCtrl';
import { UserListingRoute } from './User/Listing/UserListingCtrl';
import { UserLockoutsRoute } from './User/Lockouts/UserLockoutsCtrl';
import { UserLoginRoute } from './User/Login/UserLoginCtrl';
import { UserMergeRoute } from './User/Merge/UserMergeCtrl';
import { UserPreferencesAccountRoute } from './User/Preferences/Account/UserPreferencesAccountCtrl';
import { UserPreferencesAutoEmailsRoute } from './User/Preferences/AutoEmails/UserPreferencesAutoEmailsCtrl';
import { UserPreferencesRetentionManagementRoute } from './User/Preferences/RetentionManagement/UserPreferencesRetentionManagementCtrl';
import { UserPreferencesUnsubscribeAnonRoute } from './User/Preferences/Unsubscribe/UserPreferencesUnsubscribeAnonCtrl';
import { UserPreferencesUnsubscribeRoute } from './User/Preferences/Unsubscribe/UserPreferencesUnsubscribeCtrl';
import { VideoTranscriptionBetaConfirmationRoute } from './VideoTranscription/BetaConfirmation/VideoTranscriptionBetaConfirmationCtrl';
import { VideoTranscriptionUserPromptRoute } from './VideoTranscription/UserPrompt/VideoTranscriptionUserPromptCtrl';
// END
const dependencies = [
	// BEGIN Sharpr dependencies
	'sh.accessRules',
	'sh.accordion',
	'sh.addContent',
	'sh.afterChange',
	'sh.afterPaste',
	'sh.announcement',
	'sh.api',
	'sh.appendTo',
	'sh.attListIcons',
	'sh.attListPopup',
	'sh.attListThumbnails',
	'sh.attService',
	'sh.attSlideshow',
	'sh.attViewerAudio',
	'sh.attViewerImage',
	'sh.attViewerOther',
	'sh.attViewerPrizm',
	'sh.attViewerVideo',
	'sh.audioPlayer',
	'sh.auth',
	'sh.autoArchive',
	'sh.autopatch',
	'sh.avatar',
	'sh.bindHtml',
	'sh.bytesToText',
	'sh.cfg',
	'sh.charsRemain',
	'sh.chartBarHorizontal',
	'sh.checkboxList',
	'sh.chooseHomePage',
	'sh.clearableInput',
	'sh.clickToDownload',
	'sh.clientChooser',
	'sh.collapsible',
	'sh.colorScheme',
	'sh.columnized',
	'sh.commentButton',
	'sh.contextmenu',
	'sh.cookies',
	'sh.copyToClipboard',
	'sh.customColorChooser',
	'sh.dashboard',
	'sh.dataTable',
	'sh.dateFormat',
	'sh.dateHuman',
	'sh.dateOffset',
	'sh.datePicker',
	'sh.dateRangePicker',
	'sh.detectFocus',
	'sh.durationHuman',
	'sh.editableField',
	'sh.ellipsis',
	'sh.emailPostClicks',
	'sh.embedEdit',
	'sh.embedIframe',
	'sh.embedListing',
	'sh.embedPowerBi',
	'sh.embedTableau',
	'sh.errorLogger',
	'sh.errorScreen',
	'sh.eventTracker',
	'sh.fauxSelect',
	'sh.fileDrag',
	'sh.fileDuplicatesModal',
	'sh.filterByString',
	'sh.filterMessage',
	'sh.fineTuneCheckboxes',
	'sh.fineTuneMultihub',
	'sh.fineTunePosts',
	'sh.fineTuneTypeahead',
	'sh.fineTuneVideos',
	'sh.fitText',
	'sh.focusWhen',
	'sh.fullscreen',
	'sh.header',
	'sh.headerAvatar',
	'sh.htmlLinky',
	'sh.htmlToText',
	'sh.htmlUnmixContent',
	'sh.hubChooser',
	'sh.identity',
	'sh.image',
	'sh.imageCarousel',
	'sh.imageLoaded',
	'sh.imagePicker',
	'sh.imagePickerChoices',
	'sh.imagePickerSearch',
	'sh.imageResized',
	'sh.imageSizer',
	'sh.impersonationBar',
	'sh.impersonatorHelper',
	'sh.inputAutowidth',
	'sh.inputIcon',
	'sh.layoutAdmin',
	'sh.layoutBiReports',
	'sh.layoutUserPrefs',
	'sh.leftOrMiddleClick',
	'sh.likeButton',
	'sh.location',
	'sh.logger',
	'sh.login',
	'sh.masonryTimer',
	'sh.mentionable',
	'sh.menu',
	'sh.metricEventItem',
	'sh.middleClick',
	'sh.modal',
	'sh.msalAuth',
	'sh.multiselect',
	'sh.neatSelect',
	'sh.newsroom.masonry',
	'sh.nl2br',
	'sh.notifications',
	'sh.onInput',
	'sh.onOutsideClick',
	'sh.overlay',
	'sh.pagination',
	'sh.partnerLinks',
	'sh.patch',
	'sh.percentRounding',
	'sh.photoCollage',
	'sh.pocketLint',
	'sh.postActions',
	'sh.postBubble',
	'sh.postCategoryBar',
	'sh.postClassificationBar',
	'sh.postClassificationWithPostType',
	'sh.postCredit',
	'sh.postEditor',
	'sh.postGridIntel',
	'sh.postHero',
	'sh.postHistory',
	'sh.postImage',
	'sh.postImageArea',
	'sh.postIndicators',
	'sh.postPinBody',
	'sh.postPinFooter',
	'sh.postPinIntel',
	'sh.postPinMultihub',
	'sh.postPinUnapproved',
	'sh.postReadMore',
	'sh.postService',
	'sh.postSimple',
	'sh.postSource',
	'sh.postTabularIntel',
	'sh.postTabularMultihub',
	'sh.postTaxonomy',
	'sh.progressBackground',
	'sh.progressBar',
	'sh.pubnub',
	'sh.reactHref',
	'sh.richtext',
	'sh.richtitle',
	'sh.routerTitle',
	'sh.savedSearches',
	'sh.scopeLinkedPosts',
	'sh.scrollManager',
	'sh.searchAndChoose',
	'sh.searchBar',
	'sh.searchInput',
	'sh.searchPills',
	'sh.searchTermsAndTuner',
	'sh.secureStorage',
	'sh.select',
	'sh.sendReferrer',
	'sh.settingsTable',
	'sh.sharprEventTracker',
	'sh.slideHorizontal',
	'sh.snapEngage',
	'sh.sort',
	'sh.spinner',
	'sh.sticky',
	'sh.storage',
	'sh.tabs',
	'sh.tagCloud',
	'sh.taxonomy',
	'sh.theme',
	'sh.timePicker',
	'sh.timeZone',
	'sh.timeZonePicker',
	'sh.topContributorsBar',
	'sh.truncate',
	'sh.trusted',
	'sh.typeaheadMulti',
	'sh.typeaheadSelect',
	'sh.typeaheadSelectAccount',
	'sh.typeaheadSelectHub',
	'sh.typeaheadSingle',
	'sh.uiSref',
	'sh.upload',
	'sh.uploadArea',
	'sh.urlData',
	'sh.userEdit',
	'sh.videoPlayer',
	'sh.visualTagDisplay',
	'sh.visualTagPicker',
	'sh.zIndexTop',
	// END
	// BEGIN Vendor dependencies
	'angular-clipboard',
	'angular-loading-bar',
	'angular-sortable-view',
	'angularRipple',
	'angularUtils.directives.dirPagination',
	'ngSanitize',
	'textareaAutosize',
	'ui.router',
	'colorpicker.module',
	// END
];

/* note that we are hub */
window.isMobile = false;
document.documentElement.className += ' app-hub';
try {
	const jwt = localStorage.getItem('jwt');
	// We aren't sure why this removeItem('jwt') is here
	// but we are going to try and leave it as often as possible
	if (window.IS_LOCAL_INSTALL && jwt && jwt.payload && !jwt.payload.impersonator) {
		localStorage.removeItem('jwt');
	}
} catch (e) {
	// ... and release
}

angular
	.module('hub', dependencies)
	.config(hubBaseRoute)
	.config(hubLoggedinBaseRoute)
	.config(setDebugMode)
	.config(setSceOptions)
	.run(restrictRouteByPermission)
	.run(injectPageViewTracker)
	.run(injectImpersonatorHelper)
	.run(checkForAnnouncements)
	.run(setDocumentClass)
	// BEGIN Register controllers
	.config(AffiliationAnalytics)
	.config(AffiliationHub)
	.config(AffiliationLanguageRoute)
	.config(AffiliationListing)
	.config(AffiliationNewHubRoute)
	.config(AutoEmailRoute)
	.config(CategoryManagerRoute)
	.config(ClassificationManagerRoute)
	.config(ColumnarStoryBoardRoute)
	.config(CrossPostSubscriptions)
	.config(CurateSearchRoute)
	.config(CustomLinkImportRoute)
	.config(EcosystemOverviewRoute)
	.config(EmailAddressBookRoute)
	.config(EmailAutoEmailReportRoute)
	.config(EmailComposeRoute)
	.config(EmailContactsEditRoute)
	.config(EmailContactsListingRoute)
	.config(EmailDistListAddUserRoute)
	.config(EmailDistListEditRoute)
	.config(EmailDistListImportRoute)
	.config(EmailDistListListingRoute)
	.config(EmailListingRoute)
	.config(EmailRecipientsRoute)
	.config(EmailReportRoute)
	.config(EmailVerificationRoute)
	.config(EventsSearchRoute)
	.config(EventsUsersRoute)
	.config(FileDashboardRoute)
	.config(FileListingRoute)
	.config(FileMetadataListRoute)
	.config(FileReportRoute)
	.config(FileStatusRoute)
	.config(Http404)
	.config(HubListingRoute)
	.config(IntegrationBoxRoute)
	.config(IntegrationEmbedRoute)
	.config(IntegrationIframeRoute)
	.config(IntegrationManagerRoute)
	.config(IntegrationMsTeamsRoute)
	.config(IntegrationSalesforceRoute)
	.config(IntegrationServicenowAddEditRoute)
	.config(IntegrationServicenowListingRoute)
	.config(IntegrationSlackRoute)
	.config(KeywordMapAddRoute)
	.config(KeywordMapEditRoute)
	.config(KeywordMapImportRoute)
	.config(KeywordMapListingRoute)
	.config(MsTeamsPostRoute)
	.config(NewsroomChooser)
	.config(NewsroomColorScheme)
	.config(NewsroomCustomColorSchemeRoute)
	.config(NewsroomScreenAddedit)
	.config(NewsroomScreenListing)
	.config(NewsroomScreenRunMasonry)
	.config(NewsroomScreenRunSingle)
	.config(NewsroomScreenRunTwitter)
	.config(NewsroomScreenRunVideo)
	.config(PhotoManagerRoute)
	.config(PostAttListRoute)
	.config(PostBulkUpdateRoute)
	.config(PostCopyRoute)
	.config(PostCreateFromExternalRoute)
	.config(PostCreateRoute)
	.config(PostDetail)
	.config(PostEditRoute)
	.config(PostHistoryRoute)
	.config(PostImportRoute)
	.config(PostListingRoute)
	.config(PostPickerRoute)
	.config(PostUnarchiveRoute)
	.config(QuestionPhraseListingRoute)
	.config(ReportLandingRoute)
	.config(ReportTilesRoute)
	.config(ReportViewerRoute)
	.config(SearchSuggestRoute)
	.config(SearchTestTextRoute)
	.config(SettingsClientCredentialsAddEditRoute)
	.config(SettingsClientCredentialsListingRoute)
	.config(SettingsCookiesAnonymousRoute)
	.config(SettingsCookiesRoute)
	.config(SettingsElasticSearchIndexesRoute)
	.config(SettingsElasticSearchLanguagesRoute)
	.config(SettingsElasticSearchReindexRoute)
	.config(SettingsEmailDomainsRoute)
	.config(SettingsForAccountRoute)
	.config(SettingsHubRoute)
	.config(SettingsSsoLinksRoute)
	.config(SlackPostRoute)
	.config(SsoAddRoute)
	.config(SsoAdminRoute)
	.config(SsoLinksRoute)
	.config(SsoMetadataRoute)
	.config(SsoNoAccessRoute)
	.config(SsoRulesetsRoute)
	.config(SsoSpsRoute)
	.config(SsoStatsRoute)
	.config(TagManagerRoute)
	.config(TopContributorStandingsRoute)
	.config(TranslationOriginalRoute)
	.config(TranslationStatusRoute)
	.config(TrustedAuthAddEditRoute)
	.config(TrustedAuthListingRoute)
	.config(UserAccessHistoryRoute)
	.config(UserActivityRoute)
	.config(UserEditRoute)
	.config(UserEmailBouncesRoute)
	.config(UserImportRoute)
	.config(UserListingRoute)
	.config(UserLockoutsRoute)
	.config(UserLoginRoute)
	.config(UserMergeRoute)
	.config(UserPreferencesAccountRoute)
	.config(UserPreferencesAutoEmailsRoute)
	.config(UserPreferencesRetentionManagementRoute)
	.config(UserPreferencesUnsubscribeAnonRoute)
	.config(UserPreferencesUnsubscribeRoute)
	.config(VideoTranscriptionBetaConfirmationRoute)
	.config(VideoTranscriptionUserPromptRoute);
// END
